import { IAnalyticsScorecard } from '@/types/analytics';
import { Get } from '../helpers';

const GetEventAttendanceRate = ({
  projectUuid,
  signal,
}: {
  projectUuid: string;
  signal?: AbortSignal;
}): Promise<Pick<IAnalyticsScorecard, 'value'> | null> => {
  return Get({
    path: `/v3/admin/metrics/events/${projectUuid}/attendance-rate`,
    signal,
    isMetrics: true,
  });
};

export default GetEventAttendanceRate;
